import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Validators } from "@angular/forms";
import { Subscription, from } from "rxjs";
import { ApplicationSteps } from "../../../../models/applications.models";
import { AuthService } from "../../../../../services/auth.service";
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { GisQueryService } from "../../../../../gis/services/gis-query.service";
import { GisTokenService } from "../../../../../gis/services/gis-token.service";
import { LoaderService } from "../../../../../common/services/loader.service";

@Component({
    selector: 'app-water-source',
    templateUrl: './water-source.component.html',
    styleUrls: ['../../../../../core/components/collapsible/collapsible.component.scss', '../../../application-section-base/application-section-base.component.scss', './water-source.component.scss'],
    standalone: false
})
export class WaterSourceComponent extends ApplicationSectionBaseComponent implements OnInit, OnDestroy {

    

    get latitude(): number | null {
        if (this.form == null) return null;
        let ctrl = this.form.get('latitude');
        if (ctrl == null) return null;
        return (ctrl.value != null)
            ? <number>ctrl.value
            : null;
    }

    get longitude(): number | null {
        if (this.form == null) return null;
        let ctrl = this.form.get('longitude');
        if (ctrl == null) return null;
        return (ctrl.value != null)
            ? <number>ctrl.value
            : null;
    }

    get requireWatershedValidation(): boolean {
        return this.latitude != null && this.longitude != null;
    }

    readonly step: ApplicationSteps = ApplicationSteps.WaterSource;

    subscription: Subscription = new Subscription();

    validationRequiredHelpText: string = "When providing a latitude and longitude, watershed must be validated against GIS instead of selected.";

    @Output() watershedCoordinatesChanged: EventEmitter<any> = new EventEmitter<any>();

    watershedHelpText: string = "e.g., recycled water or water from a non-Ohio watershed";

    constructor(_auth: AuthService, private queryService: GisQueryService, private loader: LoaderService) { super(_auth); }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    coordinateChanged(value: any): void {
        this.watershedCoordinatesChanged.emit(value);
    }

    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }

    validateWatershed(): void {

        let latitude = Number(this.form.get('latitude').value);
        let longitude = Number(this.form.get('longitude').value);
        let latLong: number[] = [latitude, longitude];
        this.loader.toggleLoader(true);
        let query$ = this.queryService.queryLayerAtPoint_Unauthenticated(this.queryService.config.watershedServicesUrl, latLong);
        let subs$ = from(query$).pipe()
            .subscribe(
                (res: any) => {
                    if (res! + null && res.features != null && res.features.length > 0) {
                        if (res.features[0]["attributes"] != null && res.features[0]["attributes"]["huc6"] != null) {
                            if (res.features[0]["attributes"]["huc6"].startsWith("041")) {
                                this.form.get('watershed').setValue("LAKEERIE");
                            } else {
                                this.form.get('watershed').setValue("OHIORIVER");
                            }
                            this.form.get('watershedValidated').setValue(true);
                        }
                    }
                    this.loader.toggleLoader(false);
                },
                (error) => {
                    console.error(error);
                    this.loader.toggleLoader(false);
                }
        );
        this.subscription.add(subs$);
    }

    watershedChanged(value: string): void {
        if (this.form != null) {
            let otherCtrl = this.form.get("watershedOther");
            if (otherCtrl != null) {
                if (value == "OTHER") {
                    otherCtrl.enable();
                    otherCtrl.setValidators([Validators.required]);
                } else {
                    otherCtrl.setValue(null);
                    otherCtrl.clearValidators();
                    otherCtrl.disable();
                }
                otherCtrl.updateValueAndValidity()
            }
        }
    }
}
